
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data() {
    return {
      lng: lng,
      order: {
        data: {}
      }
    };
  },

  on: {
    pageAfterIn(e, page) {
      this.getOrder();
    }

  },
  methods: {
    getOrder() {
      const self = this,
            app = this.$app,
            $ = this.$;
      app.preloader.show();
      myApp.server.get('imc/order/' + self.$route.params.id).then(succ => {
        //console.log(succ);
        self.$setState({
          order: succ
        });
      }).catch(err => {
        console.log(err);
        app.toast.show({
          text: lng.genericError,
          closeTimeout: 3000,
          cssClass: 'bg-color-red',
          position: 'bottom'
        });
      }).finally(() => {
        app.preloader.hide();
      });
    }

  },
  id: 'b5d0eeac3a',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n\n        <div class="right">\n          <a href="/">\n            <i class="icon f7-icons">house</i>\n          </a>\n        </div>\n      </div>\n    </div>\n    <div class="page-content bg-color-white">\n      ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.order.dt, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n      <div class=\'block\'>\n        <p>\n          ';
          r += c(ctx_2.lng.orderDate, ctx_2);
          r += ':\n          ';
          r += Template7Helpers.js.call(ctx_2, "new Date(this.order.dt * 1000).toLocaleString()", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n        </p>\n        <div class=\'menu-card\'>\n          <h2>\n            ';
          r += c(ctx_2.order.poi_name, ctx_2);
          r += ' <br> \n            <small class=\'text-normal\'>\n              ';
          r += c(ctx_2.order.poi_adress, ctx_2);
          r += ' ';
          r += c(ctx_2.order.poi_city, ctx_2);
          r += '\n            </small>\n          </h2>\n        </div>\n\n      </div>\n\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n      <div class="list no-hairline no-border no-hairline-top no-hairline-bottom mt-0">\n        <ul>\n          ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.order.data.order, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          ';
          r += Template7Helpers.js_if.call(ctx_2, "this.q > 0", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <li class="row padding-horizontal border-top">\n            <div class="col-50 text-align-left">';
              r += c(ctx_3.caption, ctx_3);
              r += '</div>\n            <div class="col-20 text-align-right">';
              r += c(ctx_3.q, ctx_3);
              r += ' X</div>\n            <div class="col-30 text-align-right">';
              r += c(root.order.data.currency, ctx_3);
              r += ' ';
              r += Template7Helpers.js.call(ctx_3, "(this.price *1).toFixed(2).toLocaleString()", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</div>\n          </li>\n          ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' \n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.order.dt, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <li><hr></li>\n          <li class="row padding-horizontal">\n            <div class="col-60 text-align-left text-bold">TOTALE ORDINE</div>\n            <div class="col-40 text-align-right">';
          r += c(ctx_2.order.data.currency, ctx_2);
          r += ' ';
          r += Template7Helpers.js.call(ctx_2, "(this.order.data.order_price * 1).toFixed(2)", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div>\n          </li>\n          ';
          r += Template7Helpers.js_if.call(ctx_2, "this.order.data.order_mode == 'delivery'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <li> <hr> </li>\n          <li class="padding-horizontal row">\n            <div class=\'col-60\'>Delivery</div>\n            <div class=\'col-40 text-align-right\'>';
              r += c(ctx_3.order.data.currency, ctx_3);
              r += ' ';
              r += Template7Helpers.js.call(ctx_3, "(this.order.data.delivery_price * 1).toFixed(2)", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</div>\n          </li>\n          ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n          <li><hr></li><!-- comment -->\n          <li class="padding bold text-uppercase row">\n            <div class="col-60">TOTALE</div>\n            <div class="col-40 text-align-right">\n              ';
          r += c(ctx_2.order.data.currency, ctx_2);
          r += ' ';
          r += Template7Helpers.js.call(ctx_2, "(this.order.data.total_price * 1).toFixed(2)", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            </div>\n          </li>\n\n          ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.order.data.order_mode, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <li class=\'padding\'>\n            ';
              r += c(ctx_3.lng.mode, ctx_3);
              r += ': <span class=\'text-uppercase text-bold\'>';
              r += c(ctx_3.order.data.order_mode, ctx_3);
              r += '</span>\n          </li>\n          ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n          <li class=\'padding-horizontal\'>\n            Status: <span class=\'orderstatus-';
          r += c(ctx_2.order.status, ctx_2);
          r += '\'>';
          r += Template7Helpers.js.call(ctx_2, "lng.orderStatus[this.order.status]", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</span>\n          </li>\n          \n          ';
          r += Template7Helpers.js_if.call(ctx_2, "this.order.data.order_mode == 'delivery'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <li class="padding">\n            ';
              r += c(ctx_3.lng.deliveryAddress, ctx_3);
              r += ': ';
              r += c(ctx_3.order.delivery_addr, ctx_3);
              r += '\n          </li>\n          ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n          \n          <li class="padding-horizontal">\n            ';
          r += c(ctx_2.lng.notes, ctx_2);
          r += ': ';
          r += c(ctx_2.order.data.notes, ctx_2);
          r += '\n          </li>\n          \n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <!-- /order.dt -->\n        </ul>\n      </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    